import exportNameMapper from './ExportNameMapper'

const exportProjectNameMapper = (projectData, postFix) => {
  const projectName = projectData?.name || 'Delve Project';
  const exportFileName = exportNameMapper(projectName, postFix)
  return {projectName, exportFileName};
}

export default exportProjectNameMapper
